import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("brokenrp_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  settings: () => client.get("/settings").then((r) => r.data),
  categories: () => client.get("/categories").then((r) => r.data),
  products: (params) => client.get("/products", { params }).then((r) => r.data),
  product: (slug) => client.get(`/products/${slug}`).then((r) => r.data),

  me: () => client.get("/auth/me").then((r) => r.data),
  discordDemo: (payload) => client.post("/auth/discord/demo", payload).then((r) => r.data),
  discordUrl: () => client.get("/auth/discord/url").then((r) => r.data),
  linkFivem: (fivem_id) => client.post("/auth/link-fivem", { fivem_id }).then((r) => r.data),
  adminLogin: (email, password) => client.post("/auth/admin/login", { email, password }).then((r) => r.data),
  changeAdminPassword: (current_password, new_password) =>
    client.post("/auth/admin/change-password", { current_password, new_password }).then((r) => r.data),

  createOrder: (payload) => client.post("/orders", payload).then((r) => r.data),
  captureOrder: (order_id, paypal_order_id = null) =>
    client.post(`/orders/${order_id}/capture`, { paypal_order_id }).then((r) => r.data),
  myOrders: () => client.get("/orders/me").then((r) => r.data),

  // admin
  adminOrders: () => client.get("/admin/orders").then((r) => r.data),
  adminStats: () => client.get("/admin/stats").then((r) => r.data),
  adminUpdateOrder: (id, status) => client.put(`/admin/orders/${id}`, { status }).then((r) => r.data),
  adminCreateProduct: (p) => client.post("/admin/products", p).then((r) => r.data),
  adminUpdateProduct: (id, p) => client.put(`/admin/products/${id}`, p).then((r) => r.data),
  adminDeleteProduct: (id) => client.delete(`/admin/products/${id}`).then((r) => r.data),
};

export default client;
